import { SwitchableTabType } from 'src/lib/types/random'
import { CustomizeUIStateType, ThankYouPageConfigType, TrustBadgesConfigType } from 'src/lib/types/customizeUI'
import { FeatureState } from 'src/components/ui-customization/sub-components/thankyou-page/types'

export const customizeUITabList: SwitchableTabType[] = [
  {
    isActive: true,
    label: 'Elements',
    name: 'ELEMENTS',
    childComponent: 'ElementsTab'
  },
  {
    isActive: false,
    label: 'Brand',
    name: 'BRAND',
    childComponent: 'BrandTab'
  },
  {
    isActive: false,
    label: 'Login',
    name: 'LOGIN',
    childComponent: 'LoginTab'
  },
  {
    isActive: false,
    label: 'Coupons',
    name: 'COUPONS',
    childComponent: 'CouponsTab'
  },
  {
    isActive: false,
    label: 'Address',
    name: 'ADDRESS',
    childComponent: 'AddressTab'
  },
  {
    isActive: false,
    label: 'Payment',
    name: 'PAYMENT',
    childComponent: 'PaymentsTab'
  },
  {
    isActive: false,
    label: 'Order Confirmation',
    name: 'ORDER_CONFIRMATION',
    showIndependentTab: true,
    childComponent: 'OrderConfirmationTab'
  }
]

export const thankYouPageDefaultState: FeatureState = {
  LOGO: {
    disabled: false,
    weight: 1
  },
  BANNER: {
    disabled: false,
    banner_text: '',
    banner_background_colour: '#A5C4E640',
    banner_text_colour: '#000000',
    weight: 2
  },
  ORDER_STATUS_ETD: {
    disabled: false,
    weight: 3,
    order_placed_text: 'Thank you for your order!',
    order_status_text_colour: '#000000',
    order_status_border_colour: '#A5C4E640'
  },
  DELIVERY_INFO: {
    disabled: false,
    weight: 4
  },
  CONTACT_DETAILS: {
    disabled: false,
    weight: 5
  },
  ORDER_SUMMARY: {
    disabled: false,
    weight: 6
  },
  BILL_INFO: {
    disabled: false,
    weight: 7
  },
  HELP: {
    disabled: false,
    email: '',
    button_colour: '#596F89',
    button_text_colour: '#FFFFFF',
    weight: 8
  },
  COD_TO_PREPAID: {
    disabled: false,
    offer_text: 'offer text here',
    heading_colour: '#7796B8',
    sub_heading_colour: '#7796B8',
    cta_text_color: '#596F89',
    cta_color: '#A5C4E640',
    background_color: '#A5C4E640',
    weight: 9
  },
  TRUST_BADGE: {
    disabled: false,
    weight: 10
  }
}

export const defaultTrustBadgesConfig: TrustBadgesConfigType = {
  showBadges: false,
  badges: [
    {
      text: '',
      label: 'star',
      weight: 0,
      imgPath: '/images/badges/star.svg',
      isActive: false
    },
    {
      text: '',
      label: 'smile',
      weight: 0,
      imgPath: '/images/badges/smile.svg',
      isActive: false
    },
    {
      text: '',
      label: 'lock',
      weight: 0,
      imgPath: '/images/badges/lock.svg',
      isActive: false
    },
    {
      text: '',
      label: 'truck',
      weight: 0,
      imgPath: '/images/badges/truck.svg',
      isActive: false
    },
    {
      label: 'globe',
      imgPath: '/images/badges/globe.svg',
      isActive: false
    },
    {
      label: 'return',
      imgPath: '/images/badges/return.svg',
      isActive: false
    },
    {
      label: 'clock',
      imgPath: '/images/badges/clock.svg',
      isActive: false
    }
  ]
}

export const defaultCustomizeUIState: CustomizeUIStateType = {
  tabList: customizeUITabList,
  brandLogoURL: '',
  colorPalette: {
    primaryColor: '#fff',
    primaryTextColor: '#000'
  },
  bannerConfigs: {
    loginBanner: {
      color: '',
      textColor: '',
      text: '',
      enabled: false
    },
    addressBanner: {
      color: '',
      textColor: '',
      text: '',
      enabled: false
    },
    paymentBanner: {
      color: '',
      textColor: '',
      text: '',
      enabled: false
    }
  },
  buttonCTATexts: {
    loginButtonCTAText: '',
    addressButtonCTAText: ''
  },
  couponVisibilityConfig: {
    loginCouponVisibility: {
      areCouponsVisible: true,
      visibilityExtent: 'codeEntry'
    },
    addressCouponVisibility: {
      areCouponsVisible: true,
      visibilityExtent: 'codeEntry'
    },
    paymentsCouponVisibility: {
      areCouponsVisible: true,
      visibilityExtent: 'codeEntry'
    }
  },
  deliveryInfoConfig: {
    isVisible: false,
    deliveryInfoText: '',
    isETDEnabled: false
  },
  paymentMethodsConfig: [],
  couponEditorConfig: [],
  trustBadgesConfig: defaultTrustBadgesConfig,
  orderSummaryConfig: {
    isOrderSummaryOpen: false,
    isPriceStrikeThroughEnabled: false,
    isQuantityEditable: false,
    isOnePageCheckoutEnable: false,
    showOrderSummaryAs: 'TILE'
  },
  etdProviders: [],
  thankYouPageConfig: {
    mainFeatureState: thankYouPageDefaultState
  }
}

export const couponVisibilityEditorRadioItemsConfig = [
  {
    label: 'As coupon cards',
    valueType: 'cards'
  },
  {
    label: 'As code entry field',
    valueType: 'codeEntry'
  }
]

export enum OrderSummaryVisibilityType {
  TILE = 'TILE',
  HEADER = 'HEADER'
}
